import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { AlmoxarifadoDBService } from '../database/almoxarifado-db.service';

@Injectable({
  providedIn: 'root'
})
export class AlmoxarifadoService extends BaseService{
    override classname: string = 'AlmoxarifadoService';
    public override route = 'almoxarifado';
    public override database = new AlmoxarifadoDBService();
}
